import { render, staticRenderFns } from "./MerchantWithdrawal.vue?vue&type=template&id=00a04e30&scoped=true"
import script from "./MerchantWithdrawal.vue?vue&type=script&lang=js"
export * from "./MerchantWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./MerchantWithdrawal.vue?vue&type=style&index=0&id=00a04e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a04e30",
  null
  
)

export default component.exports